import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var Center = function Center(_ref) {
  var horizontally = _ref.horizontally,
    vertically = _ref.vertically,
    children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('ptr-center', {
      horizontally: horizontally,
      vertically: vertically
    }),
    children: children
  });
};
Center.propTypes = {
  children: PropTypes.node,
  horizontally: PropTypes.bool,
  vertically: PropTypes.bool
};
export default Center;